import { useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  Grid,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Select from "@mui/material/Select";
import { get, post } from "src/utils/networkUtils";

export default function BuyCardDialog(props) {
  const [userId, setUserId] = useState(null);
  const [users, setUsers] = useState(null);

  useEffect(() => {
    get(`/admin/users`).then(function (response) {
      setUsers(response.users);
    });
  }, []);

  const onSuccess = () => {
    props.setLoading(true);
    post(`/admin/marketplace/cards/${props.cardId}/buy`, {
      buyerId: userId,
    }).then(function (response) {
      props.onSuccessHandler();
    });
  };
  const onCancel = () => {
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Buy Card</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={8} sx={{ m: 0, p: 1 }}>
            <FormControl sx={{ m: 1, minWidth: 320 }} size="small">
              <InputLabel id="demo-simple-select-label">User</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={userId}
                label="User"
                onChange={(event) => setUserId(event.target.value)}
              >
                {users !== null &&
                  users.map((user, index) => (
                    <MenuItem
                      value={user.userId}
                      key={`competition-${user.userId}`}
                    >
                      {user.firstName} {user.lastName}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Cancel</Button>
        <Button
          onClick={() => onSuccess()}
          autoFocus
          disabled={userId === null}
        >
          Buy
        </Button>
      </DialogActions>
    </Dialog>
  );
}
